//social media
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import jcbCC from '@src/assets/images/icons/payments/jcb-cc.png'
import amexCC from '@src/assets/images/icons/payments/amex-cc.png'
import uatpCC from '@src/assets/images/icons/payments/uatp-cc.png'
import visaCC from '@src/assets/images/icons/payments/visa-cc.png'
import dinersCC from '@src/assets/images/icons/payments/diners-cc.png'
import maestroCC from '@src/assets/images/icons/payments/maestro-cc.png'
import discoverCC from '@src/assets/images/icons/payments/discover-cc.png'
import mastercardCC from '@src/assets/images/icons/payments/mastercard-cc.png'
import { IoLogoYoutube } from 'react-icons/io5';
import { FaXTwitter, FaLinkedin } from 'react-icons/fa6';
import InstaGram from "../../assets/img/icons/linkedin.svg";
import TikTok from "../../assets/img/icons/tiktok.svg";

export const socialIcons = [
  {
    name: 'Facebook',
    icon: FaFacebook,
    color:'#0765FE'
  },
  {
    name: 'Youtube',
    icon: IoLogoYoutube,
    color:'#FF0033'
  },
  {
    name: 'Twitter',
    icon: FaXTwitter,
    color:'#333'
  },
  {
    name: 'Linkedin',
    icon: FaLinkedin,
    color:'#015EBE'
  },
  {
    name: 'Instagram',
    icon: FaInstagram,
    color:'#FD0EB5'
  },
  {
    name: 'TikTok',
    icon: FaTiktok,
    color:'#2A1016'
  },
];

export const socialIconsMapper = {
  Facebook: { icon: <FaFacebook color="#6e6b7" size={20} />, defaultUrl: 'https://www.facebook.com/' },
  Youtube: { icon: <IoLogoYoutube color="#FF0000" size={20} />, defaultUrl: 'https://www.youtube.com/' },
  Twitter: { icon: <FaXTwitter color="#000" size={18} />, defaultUrl: 'https://twitter.com/' },
  Linkedin: { icon: <FaLinkedin color="#6e6b7" size={20} />, defaultUrl: 'https://www.linkedin.com/in/' },
  Instagram: { icon: <img src={InstaGram} alt="Instagram" style={{ width: '22px', height: '22px' }} />, defaultUrl: 'https://www.instagram.com/' },
  TikTok: { icon: <img src={TikTok} alt="TikTok" style={{ width: '22px', height: '22px' }} />, defaultUrl: 'https://www.tiktok.com/' },
  // Add more icons as needed
};

export const inviteMemberColors = {
  invited: "light-info",
  requested: "light-warning",
  declined: "light-danger",
  approved: "light-success",
}
export const cardsObj = {
  jcb: jcbCC,
  uatp: uatpCC,
  visa: visaCC,
  amex: amexCC,
  diners: dinersCC,
  maestro: maestroCC,
  discover: discoverCC,
  mastercard: mastercardCC
};

export const formatMemberCount = (count) => {
  if (count < 1000) {
    return count;
  } else if (count < 10000) {
    return (count / 1000).toFixed(1) + 'K';
  } else {
    return Math.floor(count / 1000) + 'K';
  }
}


export function detectCardType(number) {
  var re = {
    electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
    maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
    dankort: /^(5019)\d+$/,
    interpayment: /^(636)\d+$/,
    unionpay: /^(62|88)\d+$/,
    visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    mastercard: /^5[1-5][0-9]{14}$/,
    amex: /^3[47][0-9]{13}$/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/
  };
  for (var key in re) {
    if (re[key].test(number)) {
      return key;
    }
  }
  return 'unknown';
}

